var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sunWrapper"},[_c('div',{staticClass:"sun",style:(_vm.opacityIntesivity)})])}
var staticRenderFns = []

export { render, staticRenderFns }